var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6536 1.50049H9.34645C4.4606 1.50049 0.5 6.24005 0.5 10.8509C0.5 14.2152 2.60752 18.1118 5.64029 19.4354L4.78956 22.4785C4.78956 23.9769 5.74308 24.3701 6.90736 23.3523L10.5056 20.2013H15.6536C20.5368 20.2013 24.5 15.4617 24.5 10.8509C24.5 6.24005 20.5394 1.50049 15.6536 1.50049Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.37549C13.0636 6.37549 13.5206 6.83244 13.5206 7.39612V9.8549H15.9794C16.543 9.8549 17 10.3118 17 10.8755C17 11.4392 16.543 11.8962 15.9794 11.8962H13.5206V14.3549C13.5206 14.9186 13.0636 15.3756 12.5 15.3756C11.9363 15.3756 11.4793 14.9186 11.4793 14.3549V11.8962H9.02055C8.45687 11.8962 7.99992 11.4392 7.99992 10.8755C7.99992 10.3118 8.45687 9.8549 9.02055 9.8549H11.4793V7.39612C11.4793 6.83244 11.9363 6.37549 12.5 6.37549Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.500488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.457a37d08f0869797d070361fb581aaa.svg";
export { ForwardRef as ReactComponent };